import { useForm } from '@domain-group/react-hooks'
import type { UseFormPayload } from '@domain-group/react-hooks'

import { toggleArray } from '@domain-group/javascript-utils'

import usePortalOption, { usePortalOptionForm } from '@hooks/usePortalOption'

import { PortalOptionModel } from '@models/types'

const defaultState = {
  name: '',
  value: '',
}

const toggleNodeProperty = (nodeProperty: typeof defaultState, portalOptionFormPayload: UseFormPayload) => {
  const { entityState: { node_properties }, setEntityState } = portalOptionFormPayload

  const updatedNodeProperties = toggleArray(node_properties, nodeProperty, { deepCompare: true })

  setEntityState({ node_properties: updatedNodeProperties })
}

const useCreateOrEditPortalOptionModal = (
  portalOption: Partial<PortalOptionModel> = {},
) => {
  const {
    callbacks,
    creating,
    updating,
  } = usePortalOption(portalOption)

  const portalOptionFormPayload = usePortalOptionForm(portalOption, { validateOn: 'change' })
  const { entityState: { node_properties } } = portalOptionFormPayload

  const nodePropertyFormPayload = useForm(
    defaultState,
    { entity: {}, requiredFields: [{ key: 'name' }, { key: 'value' }], validateOn: 'change' },
    [portalOption.id, portalOption.cache_key, node_properties?.length],
  )

  return {
    callbacks: {
      toggleNodeProperty: (nodeProperty: typeof defaultState) => (
        toggleNodeProperty(nodeProperty, portalOptionFormPayload)
      ),
      ...callbacks,
    },
    nodePropertyFormPayload,
    portalOptionFormPayload,
    loading: creating || updating,
  }
}

export default useCreateOrEditPortalOptionModal
